// extracted by mini-css-extract-plugin
module.exports = {"Customers":"Customers_Customers__3Pfux","Username":"Customers_Username__uFtPh","Expired":"Customers_Expired__uX9St"};